import React from 'react';

const BlankWrapper: React.FC = ({ children }): JSX.Element => {
    return <>{children}</>;
};

export default BlankWrapper;